"use client";

import { ChevronLeftIcon, ChevronRightIcon } from "../lifestyleIcons";

interface CarouselArrowsProps {
  label: string;
  canScrollBack: boolean;
  canScrollForward: boolean;
  onScroll: (direction: -1 | 1) => void;
}

export default function CarouselArrows({ label, canScrollBack, canScrollForward, onScroll }: CarouselArrowsProps) {
  // The design draws these as plain 32px white tiles with no outline, which
  // reads because the page behind them is grey. Hover darkens the tile instead.
  const buttonClass =
    "flex items-center justify-center w-8 h-8 text-gray-5 bg-white rounded transition-colors hover:bg-gray-6 disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    // Desktop only: the mobile design drops the arrows entirely and leaves the
    // row to be swiped, which the peeking next card already advertises.
    <div className="hidden lg:flex items-center gap-2">
      <button
        type="button"
        onClick={() => onScroll(-1)}
        disabled={!canScrollBack}
        aria-label={`Scroll ${label} back`}
        className={buttonClass}>
        {/* 16px, not the tile's 20px slot: these chevrons are drawn on a
            16-unit grid, so rendering them larger scales the 1.5px stroke the
            design asks for up with them. */}
        <ChevronLeftIcon className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => onScroll(1)}
        disabled={!canScrollForward}
        aria-label={`Scroll ${label} forward`}
        className={buttonClass}>
        <ChevronRightIcon className="w-4 h-4" />
      </button>
    </div>
  );
}
